import { css } from '@microsoft/fast-element';
import {
  genericButtonStyling,
  genericFormStyling,
  genericCardStyling,
  stylesFontFaces,
  gridButtonStyling,
  boxSizing,
  scrollbarStyles,
} from '../styles';
import './main.css';

export const MainStyles = css`
  ${stylesFontFaces}
  ${genericCardStyling}
  ${genericFormStyling}
  ${genericButtonStyling}
  ${gridButtonStyling}
  ${boxSizing}
  ${scrollbarStyles}
  :host {
    contain: content;

    --nav-height: 60px;
  }

  :host,
  zero-design-system-provider,
  .dynamic-template,
  fast-router {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .cascade-route-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: calc(100% - 32px);
    height: calc(100% - 32px);
  }

  zero-design-system-provider {
    --font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    --font-family-medium: 'Roboto-Medium', 'Roboto Medium', 'Roboto', sans-serif;
    --font-family-bold: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    --primary-color: #a9ff78;
    --secondary-color: #0bd692;
    --neutral-layer-1: #181a1f;
    --neutral-layer-2: #1f2126;
    --neutral-layer-3: #202126;
    --header-text-1: #9d9d9d;
    --white: #fff;
    --white-rgb: 255, 255, 255;
    --black: #000;
    --blue: #7eaaff;
    --error: #f9644d;
    --error-rgb: 249, 100, 77;
    --completed: #7acc79;
    --completed-rgb: 122, 204, 121;
    --side-menu-bg: #202227;
    --button-hover-bg: rgb(255 255 255 / 10%);
    --border-1: #2e3339;
    --font-color-1: var(--gray-lighter);
    --modal-footer-bg: #1c1e21;
    --top-level-tab-font: #4c4d50;
    --nest-level-tab-font: #c9c9c9;
    --nested-level-tab-selected: #23f0a6;
    --card-header-bg: #1f282d;
    --gray: #535e66;
    --gray-dark: #2b2b30;
    --gray-light: #66747d;
    --gray-lighter: #879ba6;
    --red: #8c4339;
    --red-darker: #613532;
    --red-lighter: #b54f40;
    --blue-darker: #3b4865;
    --blue-lighter: #607fbb;
    --yellow: #ffb660;
    --yellow-rgb: 255, 182, 96;
    --cyan: #47bce0;
    --purple: #654df9;
    --base-font-size: 0.8125rem;
    --type-ramp-base-font-size: var(--base-font-size);
    --cascade-light-gray: rgb(201 201 201 / 70%);
    --cascade-dark-green: #1e2c2a;
    --white-smoke: #f1f1f1;
    --cascade-light-grey: #d7d7d7;
    --cascade-silver: #ccc;
    --ultra-light-gray: rgba(255, 255, 255, 0.05);
  }

  .configuration {
    background: #fff;
    color: black;
    width: 100%;
    flex: none;
    padding: 15px;
    font-size: 12px;

    --neutral-foreground-rest: black;
    --accent-fill-rest: black;
    --accent-fill-hover: black;
    --accent-fill-active: black;
  }

  .highcharts-figure,
  .highcharts-data-table table {
    min-width: 310px;
    max-width: 1152px;
    margin: 1em auto;
  }

  .highcharts-data-table table {
    font-family: Verdana, sans-serif;
    border-collapse: collapse;
    border: 1px solid #ebebeb;
    margin: 10px auto;
    text-align: center;
    width: 100%;
    max-width: 1400px;
  }

  .highcharts-data-table caption {
    padding: 1em 0;
    font-size: 1.2em;
    color: #555;
  }

  .highcharts-data-table th {
    font-weight: 600;
    padding: 0.5em;
  }

  .highcharts-data-table td,
  .highcharts-data-table th,
  .highcharts-data-table caption {
    padding: 0.5em;
  }

  .highcharts-data-table thead tr,
  .highcharts-data-table tr:nth-child(even) {
    background: #f8f8f8;
  }

  .highcharts-data-table tr:hover {
    background: #f1f7ff;
  }
`;
